// removed by extract-text-webpack-plugin
module.exports = {"root":"_1J38kzT","item":"_1jYKL34","subItem":"_1R_1Bz4","icon":"_1ZKoJw9","iconSvg":"CAaOv0u"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Header/components/UserAccount/components/UserAccountMenu/UserAccountMenu.less
 ** module id = 739
 ** module chunks = 0
 **/